const LockSmall = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 1.33301C27.3514 1.33301 33.333 7.35247 33.333 14.749V27.333H27.333V14.8389C27.333 10.7009 24.0432 7.33301 20 7.33301C15.9568 7.33301 12.667 10.7009 12.667 14.8389V27.333H6.66699V14.749C6.66699 7.35247 12.6486 1.33301 20 1.33301Z"
      fill="#C9E3F7"
    />
    <rect x="2.6665" y="17.3335" width="34.6667" height="22.6667" fill="#0A0777" />
    <circle cx="20.0002" cy="28.6667" r="2.66667" fill="#FFCCEF" />
  </svg>
);

export default LockSmall;
